<div class="mt-3 mb-3">
    <re-captcha name="captcha" required [(ngModel)]="valid" ngDefaultControl
                (ngModelChange)="onValidChange($event)"></re-captcha>
</div>

